import { Component, Prop, Ref, Watch } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { watch } from 'fs';

@Component
export class CompleteTheLook extends ThemeComponent {
    @Ref container!: HTMLElement;
    @Ref({ required: false }) cartconvert!: HTMLElement;
    @Ref({ required: false }) sectiontitle!: HTMLElement;
    done = false;
    init() {
        if (this.cartconvert) {
            this.cartConvertRecs();
        }
    }
    @Watch('done')
    protected toggleTitle() {
        if (this.sectiontitle) {
            this.sectiontitle.classList.remove('visually-hidden');
        }
    }
    cartConvertRecs() {

        // Options for the observer (which mutations to observe)
        const config = { attributes: false, childList: true, subtree: true };

        // Callback function to execute when mutations are observed
        const callback = (mutationList: MutationRecord[], observer: MutationObserver) => {
            for (const mutation of mutationList) {
                if (this.done) { return; }
                const products = this.cartconvert.querySelectorAll('.esc_product') as unknown as HTMLElement[];
                if (products) {
                    this.getProducts(products);
                }
            }
        };

        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(this.cartconvert, config);

    }
    getProducts(prods: HTMLElement[]) {
        let count = 0;
        for (const prod of prods) {
            const url = prod.querySelector('a[href*="products"')?.getAttribute('href');
            if (!url) { return; }
            count = count + 1;
            if (count > 4) { break; }
            this.done = true;
            this.container.innerHTML = '';
            fetch(`${url}?section_id=product-card-complete`)
                .then((response) => response.text())
                .then((text) => {
                    const dump = document.createElement('div');
                    dump.innerHTML = text;
                    const target = dump.querySelector('.product__complete');
                    if (target) {
                        this.container.append(target);
                    }
                })
                .catch((e) => {
                    this.$log.warn('error', e);
                });
        }
    }
}
